import { BuildingStorefrontIcon, TrophyIcon, SparklesIcon } from "@heroicons/react/24/solid";


const data=[
    {
        icon:<TrophyIcon width={20} height={20}/>,
        heading:"Award Winning Restaurant",
        detail:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptas nostrum ratione inventore iste a distinctio nobis, quibusdam officiis doloremque tempore impedit dolore exercitationem suscipit animi omnis ab autem dolor iure?",
    },
    {
        icon:<SparklesIcon width={20} height={20}/>,
        heading:"Michelin Star Chefs",
        detail:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptas nostrum ratione inventore iste a distinctio nobis, quibusdam officiis doloremque tempore impedit dolore exercitationem suscipit animi omnis ab autem dolor iure?",
    },
    {
        icon:<BuildingStorefrontIcon width={20} height={20}/>,
        heading:"Organic Restaurants",
        detail:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptas nostrum ratione inventore iste a distinctio nobis, quibusdam officiis doloremque tempore impedit dolore exercitationem suscipit animi omnis ab autem dolor iure?",
    },
];

export default data;